import { Building2, HandCoins, MapPin, Wrench } from "lucide-react";

const WhoCanParticipate = () => {
  const criteria = [
    {
      icon: HandCoins,
      title: "Famílias com renda de até R$ 9.600/mês",
      description: "Renda familiar mensal dentro do limite do programa"
    },
    {
      icon: Building2,
      title: "Proprietários de imóveis residenciais urbanos",
      description: "Você deve ser dono do imóvel que será reformado"
    },
    {
      icon: Wrench,
      title: "Reformas simples",
      description: "Pintura, telhado, banheiro, cozinha, muro ou ampliação"
    },
    {
      icon: MapPin,
      title: "Atendimento inicial em Limeira/SP",
      description: "Programa começa atendendo a região de Limeira"
    }
  ];

  return (
    <section 
      id="quem-pode" 
      className="py-16 md:py-24"
      style={{
        background: "linear-gradient(180deg, hsl(var(--background)) 0%, hsl(var(--muted)) 100%)"
      }}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 text-foreground">
            Quem pode <span className="text-[hsl(var(--orange-strong))]">participar?</span>
          </h2>
          
          <p className="text-center text-lg text-muted-foreground mb-12 max-w-2xl mx-auto">
            Veja se você se encaixa nos critérios do programa
          </p>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {criteria.map((item, index) => {
              const Icon = item.icon;
              return (
                <div 
                  key={index}
                  className="bg-card rounded-2xl p-6 md:p-8 shadow-[var(--shadow-card)] hover:shadow-[var(--shadow-warm)] transition-all flex gap-4"
                >
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] flex items-center justify-center">
                      <Icon className="h-7 w-7 text-white" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-2 text-foreground">{item.title}</h3>
                    <p className="text-muted-foreground">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-12 bg-gradient-to-r from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] rounded-2xl p-8 text-center text-white">
            <p className="text-lg md:text-xl font-semibold">
              ✨ Mais cor, conforto e dignidade para o seu lar
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoCanParticipate;
